var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInativar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7 17C1.2325 17 0.832292 16.8335 0.499375 16.5006C0.166458 16.1677 0 15.7675 0 15.3V1.7C0 1.2325 0.166458 0.832292 0.499375 0.499375C0.832292 0.166458 1.2325 0 1.7 0H8.5L13.6 5.1V8.7975C13.3308 8.69833 13.0546 8.62396 12.7713 8.57438C12.4879 8.52479 12.1975 8.5 11.9 8.5V5.95H7.65V1.7H1.7V15.3H7.0975C7.21083 15.6258 7.3525 15.9304 7.5225 16.2138C7.6925 16.4971 7.89083 16.7592 8.1175 17H1.7ZM10.115 16.575L8.925 15.385L10.71 13.6L8.925 11.815L10.115 10.625L11.9 12.41L13.685 10.625L14.875 11.815L13.1113 13.6L14.875 15.385L13.685 16.575L11.9 14.8113L10.115 16.575Z",
    fill: "#623232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInativar);
export default __webpack_public_path__ + "static/media/inativar.bd5362930721608dd9ec8e5d3ac0abc6.svg";
export { ForwardRef as ReactComponent };